import React, { useRef, useEffect, useState, ReactElement } from 'react';
import classNames from 'classnames';
import styles from './DropdownButton.module.scss';

interface IProps {
  className?: string;
  contentClassName?: string;
  renderButton: Function;
  renderContent: Function;
}

export function DropdownButton({ className, contentClassName, renderButton, renderContent }: IProps): ReactElement {
  const [isOpen, toggleIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if ((wrapperRef.current && !wrapperRef.current.contains(event.target)) &&
        (contentRef.current && !contentRef.current.contains(event.target))) {
        toggleIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef, contentRef]);

  const toggle = () => {
    toggleIsOpen(!isOpen);
  };

  return (
    <div className={classNames(isOpen && styles.open, styles.wrapper, className)} ref={wrapperRef}>
      {renderButton({ isOpen, toggle })}
      <div className={classNames(isOpen && styles.open, !isOpen && styles.hidden, styles.content, contentClassName)} ref={contentRef}>
        {renderContent({ isOpen, toggle })}
      </div>
    </div>
  );
}
